import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { NotificationService } from 'src/app/notification.service';
import { ModulesService } from 'src/app/services/Authetication/menu-permission/modules.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveGuard  {
  constructor(private _router: Router,
    private httpClient: HttpClient,
    private _notificationService: NotificationService,
  private _modulesService: ModulesService,
  // private _dataService: DatatransferService,
  private spinner: NgxSpinnerService
  ) {
   }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    const loCurrentUserData1 = localStorage.getItem('currentUserData');
    if(loCurrentUserData1 == null || loCurrentUserData1 == undefined ) {
      return true;
    }
    else {
      this.getRoleByRoleId(loCurrentUserData.roleId);
      this.spinner.hide();
      return false;
    }

  }

  getRoleByRoleId(roleId: any) {
		this.spinner.show();
		this._modulesService.getRoleByRoleId(roleId).subscribe({
			next: (response: any) => {
				if (!!response) {
					if (response.statusCode == 200) {
						if (response.data.role.name.toLowerCase() == "super admin" || response.data.role.name.toLowerCase() == "client admin") {
							this._router.navigate(['/utilization']);
						}
            else if(response.data.role.name.toLowerCase() == "report reviewer" 
            || response.data.role.name.toLowerCase() == "approver"
            || response.data.role.name.toLowerCase() == "publisher") {
              this._router.navigate(['/workbench']);
            }
						else {
							this._router.navigate(['/requests']);
						}
					}
				}
			},
      error: (error: any) => {
				if(error.status == 401){
					this._router.navigate(['/login']);
				}
			}
    });
	}
}